import { ApiConfig } from '../../../Config.js';
import axios from 'axios';


var ValidateMerchantCtrl = function (fn, er, state, ids) {

	var config = {
		headers: {
			//'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		username: state.username,
		password: state.password
	};

	axios
		.post(ApiConfig.url.VALIDATE_USER, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { ValidateMerchantCtrl };